export default {
  header: {
    home: 'ホーム',
    categories: 'カテゴリー',
    about: '概要',
    searchPlaceholder: 'ゲームを検索...',
    toggleDarkMode: 'ダークモードに切り替え',
    toggleLightMode: 'ライトモードに切り替え',
    changeLanguage: '言語を変更'
  },
  nav: {
    home: 'ホーム',
    categories: 'カテゴリー',
    popular: '人気',
    favorites: 'お気に入り',
    search: '検索...',
    login: 'ログイン',
    register: '登録',
    myProfile: 'マイプロフィール',
    settings: '設定',
    logout: 'ログアウト',
    darkMode: 'ダークモード',
    lightMode: 'ライトモード',
    language: '言語',
    about: '概要'
  },
  footer: {
    about: '私たちについて',
    contact: 'お問い合わせ',
    contactUs: 'お問い合わせ',
    policy: 'プライバシーポリシー',
    terms: '利用規約',
    copyright: '© {year} GoGameVault. All rights reserved.',
    playOnline: 'オンラインでプレイ',
    bestGames: 'ベストゲーム',
    newGames: '新着ゲーム',
    popularGames: '人気ゲーム',
    followUs: 'フォローする',
    disclaimer: 'すべてのゲームは原作者に帰属します。当サイトは一切の権利を主張しません。',
    introText: '最高の無料オンラインゲームプラットフォーム。ダウンロード不要、登録不要、純粋な楽しさ！',
    quickLinks: 'クイックリンク',
    popularCategories: '人気カテゴリー',
    contactText: '質問、提案、フィードバックがありますか？お気軽にお問い合わせください！',
    aboutUs: '私たちについて'
  },
  gameCard: {
    play: '今すぐプレイ',
    new: '新着',
    popular: '人気'
  },
  shareButtons: {
    share: '共有',
    copyLink: 'リンクをコピー',
    facebook: 'Facebookで共有',
    twitter: 'Twitterで共有',
    whatsapp: 'WhatsAppで共有',
    telegram: 'Telegramで共有',
    copied: 'コピーしました！'
  },
  searchBar: {
    search: '検索',
    placeholder: 'お気に入りのゲームを探す...'
  },
  share: {
    title: 'シェア',
    copy: 'リンクをコピー',
    copied: 'コピーしました',
    instagramNotSupported: 'Instagramは直接リンクの共有に対応していません'
  }
}; 